import { Pagination, Table, TableColumn } from '@ks/ks-element-ui';
import { ScopedSlot } from 'vue/types/vnode';

export const inheritTableProps = [
    'data',
    'height',
    'maxHeight',
    'stripe',
    'border',
    'fit',
    'showHeader',
    'highlightCurrentRow',
    'currentRowKey',
    'lazy',
    'indent',
    'rowClassName',
    'rowStyle',
    'cellClassName',
    'cellStyle',
    'headerRowClassName',
    'headerRowStyle',
    'headerCellClassName',
    'headerCellStyle',
    'rowKey',
    'emptyText',
    'defaultExpandAll',
    'expandRowKeys',
    'defaultSort',
    'tooltipEffect',
    'showSummary',
    'sumText',
    'summaryMethod',
    'selectOnIndeterminate',
    'clearSelection',
    'toggleRowSelection',
    'toggleAllSelection',
    'setCurrentRow',
    'toggleRowExpansion',
    'clearSort',
    'clearFilter',
    'doLayout',
    'sort',
    'load',
] as const;

export const inheritTableColumnsProps = [
    'type',
    'label',
    'columnKey',
    'prop',
    'width',
    'minWidth',
    'fixed',
    'renderHeader',
    'sortable',
    'sortMethod',
    'sortOrders',
    'resizable',
    'formatter',
    'showOverflowTooltip',
    'align',
    'headerAlign',
    'className',
    'labelClassName',
    'selectable',
    'reserveSelection',
    'filters',
    'filterPlacement',
    'filterMultiple',
    'filterMethod',
    'filteredValue',
] as const;

export type Row<T = any> = {
    $index: number;
    row: T;
    column: InstanceType<typeof TableColumn>;
    // 不知道做什么用的
    isRootInsert: boolean;
    elm: HTMLElement;
};

export type Render<T> = (row: Row<T>) => ReturnType<ScopedSlot>;

export type Columns<T> = {
    render?: Render<T>;
} & Partial<
    Omit<
        Pick<
            InstanceType<typeof TableColumn>,
            typeof inheritTableColumnsProps[number]
        >,
        'prop'
    > & { prop: keyof T }
>;

export type Query = {
    sort?: {
        prop: 'date';
        order: 'ascending' | 'descending';
    };
    page: {
        currentPage: number;
        pageSize: number;
    };
    [key: string]: any;
};

export type ApiResponse<T> =
    | T[]
    | {
          total: number;
          data: T[];
      }
    | undefined;

export type ConfTableProps<T extends object = any> = {
    api?(query: Query): Promise<ApiResponse<T>> | ApiResponse<T>;
    fetchOnMounted?: boolean;
    columns: Columns<T>[];
    /**
     * 分页器
     */
    pagination?: {
        /**
         * API 查询起始页码
         */
        startPage?: number;
    } & Partial<InstanceType<typeof Pagination>>;
} & Partial<Pick<InstanceType<typeof Table>, typeof inheritTableProps[number]>>;

export interface FetchOptions {
    resetPage?: boolean;
}
